import React, { useState } from 'react';
import { SolicitudesPendientesPage } from './SolicitudesPendientesPage';
import { DemoRequestsPage } from './DemoRequestsPage';

type Tab = 'alta' | 'demo';

const TABS: { key: Tab; label: string }[] = [
  { key: 'alta', label: 'Altas de clínicas' },
  { key: 'demo', label: 'Demos' },
];

export const SolicitudesPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('alta');

  return (
    <div className="panel-page h-full min-h-0 flex flex-col overflow-hidden !space-y-4">
      <div className="flex-shrink-0">
        <h1 className="panel-page-title">Solicitudes</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
          Revisá altas de clínicas y pedidos de demo de la landing
        </p>
      </div>

      <div className="border-b border-slate-200 dark:border-gray-700 flex-shrink-0">
        <nav className="-mb-px flex gap-6">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className={`py-3 px-1 border-b-2 text-sm font-medium transition-colors ${
                activeTab === tab.key
                  ? 'border-teal-500 text-teal-600 dark:text-teal-400'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300 dark:text-slate-400 dark:hover:text-slate-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden">
        {activeTab === 'alta' ? <SolicitudesPendientesPage /> : <DemoRequestsPage />}
      </div>
    </div>
  );
};
